import {ChangeEvent} from 'react';

interface ImageUploadSectionProps {
  croppedImageFile: File | null;
  onImageRemove: () => void;
  onImageChange: (e: ChangeEvent<HTMLInputElement>) => void;
}

const ImageUploadSection = ({
  croppedImageFile,
  onImageRemove,
  onImageChange,
}: ImageUploadSectionProps) => (
  <section className="flex flex-col justify-center items-center mb-3">
    {croppedImageFile ? (
      <div className="flex flex-col w-full items-center">
        <div className="h-[416px] w-56 rounded-[8px] border-dashed border-[2px] border-gray-700 relative overflow-hidden">
          <div className="absolute rounded-[8px] bg-white flex items-center justify-center p-1 text-white left-2 top-2">
            <i
              className="icon-nameDelete text-xl text-red-600 cursor-pointer"
              onClick={onImageRemove}
            />
          </div>
          <img
            className="w-full h-[416px] object-cover"
            src={URL.createObjectURL(croppedImageFile)}
            alt="uploaded_story"
          />
        </div>
      </div>
    ) : (
      <div>
        <label
          htmlFor="imageUpload"
          className="flex items-center justify-center text-md w-40 h-72 rounded-xl border-[2px] border-dashed text-gray-500 flex-col cursor-pointer"
        >
          <i className="icon-nameImage-plus text-gray-500 text-5xl" />
        </label>
        <input
          className="hidden"
          type="file"
          id="imageUpload"
          name="imageUpload"
          accept="image/png, image/jpeg"
          onChange={onImageChange}
        />
      </div>
    )}
  </section>
);

export default ImageUploadSection;
